import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/index';

const features = [
  { title: 'Tier III Certified', desc: 'Standar uptime 99.982% dengan redundansi penuh pada sistem daya dan pendingin.', icon: '🏢' },
  { title: 'Colocation Services', desc: 'Sewa space rack dengan konektivitas berkecepatan tinggi dan keamanan fisik 24/7.', icon: '🔒' },
  { title: 'Dedicated Server', desc: 'Server fisik khusus dengan performa maksimal untuk aplikasi mission-critical.', icon: '💻' },
  { title: 'Disaster Recovery', desc: 'Sistem backup dan failover otomatis untuk menjaga kontinuitas bisnis Anda.', icon: '🛡️' },
  { title: 'Network Redundancy', desc: 'Multi-homed koneksi dengan beberapa upstream provider untuk keandalan maksimal.', icon: '🌐' },
  { title: '24/7 NOC Monitoring', desc: 'Tim Network Operations Center memantau infrastruktur tanpa henti.', icon: '📡' },
];

const DataCenterPage = () => {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white py-24 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Data Center Tier III</h1>
          <p className="text-lg md:text-xl text-blue-200 max-w-3xl mx-auto">
            Infrastruktur data center berstandar internasional dengan uptime 99.982%, 
            dilengkapi sistem keamanan fisik dan jaringan berlapis.
          </p>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-white">Keunggulan Data Center Kami</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div key={f.title} className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="text-4xl mb-4">{f.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-gray-800 dark:text-white">{f.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-blue-900 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Siap Menggunakan Data Center Kami?</h2>
          <p className="text-blue-200 mb-8">Hubungi tim kami untuk konsultasi gratis dan penawaran terbaik.</p>
          <Link to="/kontak" className="inline-block bg-white text-blue-900 font-bold px-8 py-4 rounded-xl hover:bg-blue-50 transition-colors">
            Hubungi Kami
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DataCenterPage;
